import { useEffect } from 'react';
import { Col, Divider, Row } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import config from '~/config';
import CardAboutMe from '../../components/card-about-me';
import styles from './Profile.module.scss';
import { genderList } from '~/constants';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';

const cx = classNames.bind(styles);

const Profile = () => {
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.user.userInfo);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinCaNhan');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 0, children: 0 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Personal information
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <div className={cx('right_container')}>
                        <Row justify="center" align="middle" className={cx('avatar_section')}>
                            <div className={cx('avatar')}>
                                <img src={userInfo?.avatar || IMAGES.ImagePlaceholder} alt="" />
                            </div>{' '}
                            <div className={cx('tag_type_account')}>
                                <div style={{ display: 'flex' }}>
                                    <div className={cx('name_user')}>{userInfo?.fullname || userInfo?.phone}</div>{' '}
                                    {userInfo?.is_collab ? <img src={SVGS.IconChecked} alt="" /> : ''}
                                </div>
                                {userInfo?.is_collab ? (
                                    <div className={cx('account_type')}>Contributor</div>
                                ) : (
                                    <div className={cx('account_type')}>Member</div>
                                )}
                            </div>
                        </Row>
                        <Row justify="center">
                            <Col xs={8} className={cx('item')}>
                                <Row justify="start" className={cx('label')}>
                                    Date of birth:
                                </Row>
                            </Col>
                            <Col xs={16}>
                                <Row justify="end" className={cx('content')}>
                                    {userInfo?.birthday && parseInt(userInfo?.birthday)
                                        ? moment(new Date(parseInt(userInfo?.birthday))).format('DD/MM/YYYY')
                                        : ''}
                                </Row>
                            </Col>
                        </Row>
                        <Divider />
                        <Row justify="center">
                            <Col xs={8} className={cx('item')}>
                                <Row justify="start" className={cx('label')}>
                                    Sex:
                                </Row>
                            </Col>
                            <Col xs={16}>
                                <Row justify="end" className={cx('content')}>
                                    {userInfo?.gender === genderList[0]?.value
                                        ? genderList[0]?.title
                                        : userInfo?.gender === genderList[1]?.value
                                        ? genderList[1]?.title
                                        : 'Other'}
                                </Row>
                            </Col>
                        </Row>
                        <Divider />
                        <Row justify="center">
                            <Col xs={10} className={cx('item')}>
                                <Row justify="start" className={cx('label')}>
                                    Phone number:
                                </Row>
                            </Col>
                            <Col xs={14}>
                                <Row justify="end" className={cx('content')}>
                                    {userInfo?.phone}
                                </Row>
                            </Col>
                        </Row>
                        <Divider />
                        <Row justify="center">
                            <Col xs={8} className={cx('item')}>
                                <Row justify="start" className={cx('label')}>
                                    Email:
                                </Row>
                            </Col>
                            <Col xs={16}>
                                <Row justify="end" className={cx('content')}>
                                    {userInfo?.email}
                                </Row>
                            </Col>
                        </Row>
                        <Divider />
                        {/* <Row justify="center">
                            <Col xs={6} className={cx('item')}>
                                <Row justify="start" className={cx('label')}>
                                    Address:
                                </Row>
                            </Col>
                            <Col xs={18}>
                                <Row justify="end" className={cx('content')}>
                                    {userInfo?.address}
                                </Row>
                            </Col>
                        </Row>
                        <Divider /> */}
                        <Row justify="center">
                            <div className={cx('btn_edit')} onClick={() => navigate(config.routes.editProfile)}>
                                Edit information
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
